import React from 'react';
import { transparentize } from 'polished';
import styled from 'styled-components';
import LoadingSpinner from 'components/core/loading-spinner';

type LoadingCurtainProps = {
  show?: boolean;
};

const LoadingCurtainBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => transparentize(0.75, theme.surface)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const LoadingCurtain: React.FC<LoadingCurtainProps> = ({ show }) => {
  if (!show) return null;

  return (
    <LoadingCurtainBackground>
      <LoadingSpinner size={80} />
    </LoadingCurtainBackground>
  );
};

export default LoadingCurtain;
